jQuery(function ($) {
    "use strict";
    var Engine = {
        ui: {
            misc: function () {
                $(window).on('load', function () {
                    AOS.init();
                });

                let lastScrollTop = 0;
                $(window).on('scroll', function () {
                    const currentScroll = $(window).scrollTop();
                    if (currentScroll < lastScrollTop && currentScroll >= 179) {
                        $('header').addClass('scrolled');
                    } else {
                        $('header').removeClass('scrolled');
                    }
                    lastScrollTop = currentScroll;

                    if (currentScroll > 1000) {
                        $('#back-top').fadeIn().addClass('active');
                    } else {
                        $('#back-top').fadeOut().removeClass('active');
                    }
                });

                $('#back-top').on('click', function () {
                    $('body,html').animate({ scrollTop: 0 }, 100);
                    return false;
                });

                $("#menuIcon").on('click', function () {
                    const isOpen = $(this).toggleClass('open').hasClass('open');
                    $('.top').attr('d', isOpen ? 'M1 1L19 15' : 'M2 2H25');
                    $('.middle').css('opacity', isOpen ? '0' : '1');
                    $('.bottom').attr('d', isOpen ? 'M1 15L19 1' : 'M2 18H25');
                });

                // Mp4 Video observer
                const $videos = $('.load-video');
                const videoObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        const $video = $(entry.target);
                        if (entry.isIntersecting) {
                            $video[0].play();
                        } else {
                            $video[0].pause();
                        }
                    });
                }, { threshold: 0.1 });

                $videos.each((i, video) => {
                    videoObserver.observe(video);
                });

                // Youtube observer
                let player;
                const youtubeObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        const $iframe = $(entry.target);
                        const src = $iframe.data('src');

                        // Set src immediately if not already set
                        if (!$iframe.attr('src')) {
                            $iframe.attr('src', src);
                        }

                        if (entry.isIntersecting) {
                            if (!player) {
                                player = new YT.Player($iframe[0], {
                                    events: {
                                        'onReady': function (event) {
                                            // Buffer video when player is ready
                                            event.target.mute();
                                            event.target.playVideo();
                                            // Immediately pause to pre-buffer
                                            setTimeout(() => {
                                                event.target.pauseVideo();
                                            }, 100);
                                        },
                                        'onStateChange': function (event) {
                                            if (event.data === 0) {
                                                event.target.playVideo();
                                            }
                                        }
                                    }
                                });
                            } else {
                                player.playVideo();
                            }
                        } else {
                            if (player && player.pauseVideo) {
                                player.pauseVideo();
                            }
                        }
                    });
                }, {
                    // Increase threshold to start loading earlier
                    threshold: 0.01,
                    // Add root margin to start loading before element is in view
                    rootMargin: '100px'
                });

                const tag = $('<script>').attr('src', 'https://www.youtube.com/iframe_api');
                $('script').first().before(tag);
                
                // Initialize immediately rather than waiting for observer
                $('.youtube-video').each((i, video) => {
                    const $iframe = $(video);
                    const src = $iframe.data('src');
                    $iframe.attr('src', src);
                    youtubeObserver.observe(video);
                });

                const sliderConfig = {
                    dots: false,
                    arrows: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    autoplay: true,
                    autoplaySpeed: 1,
                    speed: 6000,
                    cssEase: 'linear'
                };

                $('.clients-brands-slider, .left-brands-slider').slick(sliderConfig);

                $('.right-brands-slider').slick({ ...sliderConfig, rtl: true });

                $('.everything-slider').each(function () {
                    $(this).slick({
                        dots: false,
                        arrows: false,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                        autoplay: true,
                        autoplaySpeed: 1,
                        speed: 6000,
                        cssEase: 'linear',
                        touchThreshold: 5000,
                        centerMode: true
                    });
                });

                $('.blog-post-slider').slick({
                    dots: false,
                    arrows: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    autoplay: true,
                    touchThreshold: 5000,
                    centerMode: true
                });

                $('.tag-slider').each(function () {
                    $(this).slick({
                        dots: false,
                        arrows: false,
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                        touchThreshold: 5000
                    });
                });

                $('.about-slider').slick({ ...sliderConfig, touchThreshold: 5000 });

                $('.image-slider').each(function (index) {
                    const $imageSlider = $(this);
                    const $thumbnailSlider = $('.thumbnail-slider').eq(index);

                    $imageSlider.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false,
                        fade: true,
                        infinite: true,
                        asNavFor: $thumbnailSlider,
                        autoplay: true,
                    });

                    $thumbnailSlider.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        asNavFor: $imageSlider,
                        dots: false,
                        arrows: false,
                        variableWidth: true,
                        focusOnSelect: true,
                        draggable: false,
                    });
                });

                const $canvas = $('.canvas');
                if ($canvas.length) {
                    const canvas = $canvas[0];
                    const ctx = canvas.getContext("2d");
                    let coord = { x: 0, y: 0 };
                    let isHovering = false;

                    $(window).on("resize", resize);
                    $canvas.on("mouseenter", start);
                    $canvas.on("mouseleave", stop);
                    $canvas.on("mousemove", (event) => {
                        if (isHovering) draw(event);
                    });

                    resize();

                    function resize() {
                        const rect = canvas.getBoundingClientRect();
                        ctx.canvas.width = rect.width;
                        ctx.canvas.height = rect.height;
                    }

                    function reposition(event) {
                        const rect = canvas.getBoundingClientRect();
                        coord.x = event.clientX - rect.left;
                        coord.y = event.clientY - rect.top;
                    }

                    function start(event) {
                        isHovering = true;
                        reposition(event);
                    }

                    function stop() {
                        isHovering = false;
                    }

                    function draw(event) {
                        ctx.beginPath();
                        ctx.lineWidth = 20;
                        ctx.lineCap = "round";
                        ctx.strokeStyle = "#ffffff";
                        ctx.moveTo(coord.x, coord.y);
                        reposition(event);
                        ctx.lineTo(coord.x, coord.y);
                        ctx.stroke();
                    }
                }

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const buttonId = entry.target.id.replace('-section', '-button');
                            $('[id$="-button"]').removeClass('bg-stone-300 text-white')
                                .find('svg').removeClass('text-white');
                            $(`#${buttonId}`).addClass('bg-stone-300 text-white')
                                .find('svg').addClass('text-white');
                        }
                    });
                }, { threshold: 0.5 });

                $('[id$="-section"]').each((i, section) => observer.observe(section));


                // Handle button clicks
                $('[id$="-scrollbutton"]').on('click', function () {
                    const section = '#' + $(this).attr('id').replace('-scrollbutton', '-scrollsection');

                    // Remove active class from all scrollbuttons
                    $('[id$="-scrollbutton"]').removeClass('bg-neutral-800');
                    // Add active class to clicked scrollbutton
                    $(this).addClass('bg-neutral-800');

                    // Scroll to section
                    $('html, body').animate({
                        scrollTop: $(section).offset().top - 100
                    }, 500);
                });

                // Handle select changes
                $('#services-select').on('change', function () {
                    const section = '#' + $(this).val() + '-scrollsection';

                    // Scroll to section
                    $('html, body').animate({
                        scrollTop: $(section).offset().top - 100
                    }, 500);
                });

                // Handle scroll
                const scrollObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const service = entry.target.id.replace('-scrollsection', '');

                            // Update buttons
                            $('[id$="-scrollbutton"]').removeClass('bg-neutral-800');
                            $(`#${service}-scrollbutton`).addClass('bg-neutral-800');

                            // Update select
                            $('#services-select').val(service);
                        }
                    });
                }, {
                    threshold: 0.5,
                    rootMargin: '-100px 0px'
                });

                // Observe all sections
                $('[id$="-scrollsection"]').each((i, section) => scrollObserver.observe(section));
            }
        }
    };
    Engine.ui.misc();
});
